<template>
  <component :is="newTag" :href="href" :type="newType" :disabled="disabled" :class="[dynamicClasses]" class="btn" @click="$emit('click')">
    <div class="content flex items-center justify-center w-full">
      <slot />
    </div>
    <span v-if="loading" class="loader">
      <d-loader :size="22" :color="loaderColor" />
    </span>
  </component>
</template>

<script>
  import DLoader from '../DLoader/DLoader.vue';
  import GeneralMixin from '../../../utils/mixins/generalMixin';
  import Color from 'color'

  /**
   * @displayName Button
   */
  export default {
    name: 'DButton',
    status: 'prototype',
    release: '0.1.0',
    components: {
      DLoader,
    },
    mixins: [GeneralMixin],

    props: {
      /**
       * Set whether it is a button or a form submission
       * @parameters button, submit, reset
       */
      type: {
        type: String,
        default: null,
        validator: value => [null, 'button', 'submit', 'reset'].includes(value),
      },

      /**
       * Full width button
       */
      block: {
        type: Boolean,
        default: false,
      },

      /**
       * Use a pre-defined color (`primary-500`, etc)
       */
      color: {
        type: String,
        default: 'primary-500',
      },

      /**
       * The html element used for the button.
       * @parameters button, a
       */
      tag: {
        type: String,
        default: 'button',
        validator: value => ['button', 'a'].includes(value),
      },

      /**
       * When setting the button’s type to a link, use this option to give a href.
       */
      href: {
        type: String,
        default: null,
      },

      /**
       * Set the disabled state
       */
      disabled: {
        type: Boolean,
        default: false,
      },

      /**
       * Moves the button up slightly on hover; down slightly on active;
       */
      animatedShift: {
        type: Boolean,
        default: false,
      },

      /**
       * Set the loading state
       */
      loading: {
        type: Boolean,
        default: false,
      },

      /**
       * Makes the background transparent - color only affects the text
       */
      flat: {
        type: Boolean,
        default: false,
      },

      /**
       * Controls the font size and padding size of the button
       * @parameters xs, sm, md, lg, xl
       */
      size: {
        type: String,
        default: 'md',
        validator: value => ['xs', 'sm', 'md', 'lg', 'xl'].includes(value),
      },
    },

    data: () => ({
    //
    }),

    computed: {
      dynamicClasses() {
        return {
          [`btn-${this.color}`] : true,
          'animated-shift': this.animatedShift,
          'is-loading': this.loading,
          'w-full': this.block,
          [`btn-${this.size}`]: this.size,
          [`is-flat`]: this.flat,
        };
      },

      loaderColor() {
        if (this.flat) {
          return this.color;
        }
        return this.findTextContrastingClassColor(this.color).replace('text-', '');
      },

      newTag() {
        if (this.href) return 'a';
        return this.tag;
      },

      newType() {
        if (this.newTag === 'a') return null;
        if (!this.type && this.newTag === 'button') return 'button';
        return this.type;
      },
    },
  };
</script>